export default __webpack_public_path__ + "static/media/fingerprint-scan.a4093f20.png";